import React from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";
import useAdminAmbient from "@/hooks/useAdminAmbient";

const LEVELS = [
  { id: "full", label: "Full" },
  { id: "reduced", label: "Soft" },
  { id: "off", label: "Off" },
];

export default function AmbientControls() {
  const { preference, intensity, choose } = useAdminAmbient();
  const { isDark, toggleTheme } = useTheme();
  const active = preference || intensity;

  return (
    <div className="px-2 pt-2">
      <button
        type="button"
        onClick={toggleTheme}
        className="mb-1 flex min-h-11 w-full items-center gap-2 px-3 font-['Manrope'] text-[13px] text-white/70 hover:bg-white/5 hover:text-white"
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        {isDark ? "Light mode" : "Dark mode"}
      </button>
      <div role="group" aria-label="Background effects" className="grid grid-cols-3 gap-1">
        {LEVELS.map((level) => (
          <button
            key={level.id}
            type="button"
            aria-pressed={active === level.id}
            onClick={() => choose(level.id)}
            className={`min-h-11 font-['Manrope'] text-[11px] ${
              active === level.id ? "bg-blue-500/15 text-blue-400" : "text-white/50 hover:bg-white/5 hover:text-white/80"
            }`}
          >
            {level.label}
          </button>
        ))}
      </div>
    </div>
  );
}
